/* Rescuevation Kopf: ergänzt die <details>-Navigation um Hover-Öffnen, Escape,
   Klick-außerhalb, Sticky-Zustand und den Warenkorb-Zähler. Ohne dieses Skript
   bleibt alles bedienbar (details/summary, normale Links und Formulare). */
(() => {
  if (customElements.get('rescu-kopf')) return;

  class RescuKopf extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.shopify-section') || this;
      this.tabs = [...this.querySelectorAll('details[data-kopf-tab]')];
      this.klappen = [...this.querySelectorAll('details[data-kopf-klappe]')];
      this.hover = window.matchMedia('(hover: hover) and (min-width: 990px)');

      this.tabs.forEach((d) => this.hoverEinrichten(d));
      [...this.tabs, ...this.klappen].forEach((d) => {
        d.addEventListener('toggle', () => {
          if (!d.open) return;
          [...this.tabs, ...this.klappen].forEach((x) => { if (x !== d && !x.contains(d)) x.open = false; });
          const feld = d.querySelector('input[type="search"]');
          if (feld && d.matches('[data-kopf-such]')) setTimeout(() => feld.focus(), 30);
        });
      });

      this.querySelectorAll('details[data-kopf-modal]').forEach((d) => {
        d.addEventListener('toggle', () => {
          document.documentElement.classList.toggle('kopf-gesperrt', !!this.querySelector('details[data-kopf-modal][open]'));
          this.wrapper.style.zIndex = d.open ? '2147483000' : '';
        });
        d.querySelectorAll('[data-kopf-zu]').forEach((b) => b.addEventListener('click', () => { d.open = false; d.querySelector('summary')?.focus(); }));
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const offen = this.querySelector('details[open]');
        if (!offen) return;
        this.querySelectorAll('details[open]').forEach((d) => { d.open = false; });
        offen.querySelector('summary')?.focus();
      });
      document.addEventListener('click', (e) => {
        if (this.contains(e.target)) return;
        [...this.tabs, ...this.klappen].forEach((d) => { d.open = false; });
      });

      this.festBeobachten();
      this.korbEinrichten();
      this.suchStartEinrichten();
      this.leisteEinrichten();
      this.navigatorEinrichten();
    }

    navigatorEinrichten() {
      this.querySelectorAll('.kopf-navi__lage').forEach((lage) => {
        lage.addEventListener('mouseenter', () => {
          if (!this.hover.matches || lage.closest('.kopf-schublade')) return;
          const feld = document.getElementById(lage.htmlFor);
          if (feld) feld.checked = true;
        });
      });
    }

    leisteEinrichten() {
      const leiste = this.querySelector('.kopf-schnell');
      if (!leiste) return;
      const pfeile = [...this.querySelectorAll('[data-kopf-pfeil]')];
      const pruefen = () => {
        const rest = leiste.scrollWidth - leiste.clientWidth - leiste.scrollLeft;
        leiste.toggleAttribute('data-ende', rest < 2);
        pfeile.forEach((p) => { p.hidden = Number(p.dataset.kopfPfeil) > 0 ? rest < 2 : leiste.scrollLeft < 2; });
      };
      pfeile.forEach((p) => p.addEventListener('click', () => {
        leiste.scrollBy({ left: Number(p.dataset.kopfPfeil) * leiste.clientWidth * 0.7, behavior: 'smooth' });
      }));
      leiste.addEventListener('scroll', pruefen, { passive: true });
      window.addEventListener('resize', pruefen);
      pruefen();
    }

    hoverEinrichten(d) {
      let auf;
      let zu;
      d.addEventListener('mouseenter', () => {
        if (!this.hover.matches) return;
        clearTimeout(zu);
        auf = setTimeout(() => { d.open = true; d.dataset.hoverAuf = Date.now(); }, 90);
      });
      // Wer nach dem Hover-Öffnen noch auf den Reiter klickt, soll das Panel nicht wieder schließen.
      d.querySelector('summary')?.addEventListener('click', (e) => {
        if (this.hover.matches && d.open && Date.now() - Number(d.dataset.hoverAuf || 0) < 1500) e.preventDefault();
      });
      d.addEventListener('mouseleave', () => {
        if (!this.hover.matches) return;
        clearTimeout(auf);
        zu = setTimeout(() => { d.open = false; }, 180);
      });
    }

    festBeobachten() {
      const weg = () => parseFloat(getComputedStyle(this.wrapper).getPropertyValue('--kopf-weg')) || 0;
      // Mobil einziehen (data-kopf-einziehen): beim Herunterscrollen weg, beim Hochscrollen zurück.
      const einziehen = this.hasAttribute('data-kopf-einziehen');
      const mobil = window.matchMedia('(max-width: 989px)');
      let letzteY = window.scrollY;
      let geplant = false;
      const pruefen = () => {
        geplant = false;
        const y = window.scrollY;
        const fest = this.wrapper.getBoundingClientRect().top <= -weg() + 0.5 && y > 4;
        this.toggleAttribute('data-kopf-fest', fest);
        if (einziehen) {
          const offen = this.querySelector('details[open]');
          if (mobil.matches && !offen && y > letzteY + 2 && y > this.wrapper.offsetHeight + 40) {
            this.wrapper.style.transform = 'translateY(-100%)';
          } else if (y < letzteY - 2 || y < 10 || !mobil.matches) {
            this.wrapper.style.transform = '';
          }
          letzteY = y;
        }
      };
      // --header-height: Höhe des Teils, der beim Scrollen oben stehen bleibt. Viele Sections
      // richten ihre klebenden Elemente daran aus; bisher setzte Dawns Header den Wert.
      const hoeheMelden = () => {
        const h = Math.max(0, Math.round(this.wrapper.offsetHeight - weg()));
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      };
      hoeheMelden();
      window.addEventListener('resize', hoeheMelden);
      if ('ResizeObserver' in window) new ResizeObserver(hoeheMelden).observe(this.wrapper);
      window.addEventListener('scroll', () => {
        if (geplant) return;
        geplant = true;
        requestAnimationFrame(pruefen);
      }, { passive: true });
      pruefen();
    }

    korbEinrichten() {
      this.querySelectorAll('[data-kopf-korb]').forEach((a) => {
        a.addEventListener('click', (e) => {
          const schublade = document.querySelector('cart-drawer');
          if (!schublade || typeof schublade.open !== 'function') return;
          e.preventDefault();
          schublade.open(a);
        });
      });
      let geplant;
      const zaehlen = () => {
        clearTimeout(geplant);
        geplant = setTimeout(() => {
          fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((c) => {
              this.querySelectorAll('[data-kopf-zahl]').forEach((z) => {
                z.textContent = c.item_count;
                z.hidden = c.item_count < 1;
              });
            })
            .catch(() => {});
        }, 120);
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, zaehlen);
      // Die Warenkorb-Schublade (rescu-drw.js) und Dawns cart.js melden Änderungen nur, indem sie
      // #cart-icon-bubble neu befüllen. Im Live-Kopf ist das ein unsichtbares Ersatz-Element.
      const ersatz = document.getElementById('cart-icon-bubble');
      if (ersatz && 'MutationObserver' in window) new MutationObserver(zaehlen).observe(ersatz, { childList: true, subtree: true });
    }

    suchStartEinrichten() {
      this.querySelectorAll('.kopf-suche').forEach((box) => {
        const start = box.querySelector('[data-kopf-suchstart]');
        const feld = box.querySelector('input[type="search"]');
        if (!start || !feld) return;
        const zeigen = () => box.toggleAttribute('data-start', document.activeElement === feld && !feld.value.trim());
        feld.addEventListener('focus', zeigen);
        feld.addEventListener('input', zeigen);
        box.addEventListener('focusout', () => setTimeout(() => {
          if (!box.contains(document.activeElement)) box.removeAttribute('data-start');
        }, 120));
      });
    }
  }

  customElements.define('rescu-kopf', RescuKopf);
})();
